/**
 * 検証
 */

/**
 * NULL 判定
 * @param value
 * @returns 
 */
export const IsNull = (value:any) :boolean => {
    return (value === null);
}

/**
 * undefined判定
 * @returns 
 */
export const IsUndefined = (value:any):boolean => {
    return (value === undefined);
}

/**
 * Null、または、undefind判定
 * @param value 
 */
export const IsNullOrUndefind = (value:any):boolean => {
    return (value == null);
}

/**
 * 空文字判定
 * @param value
 */
export const IsEmpty = (value:string):boolean => {
    return (value === "");
}

/**
 * Null、または、空文字
 */
export const IsNullOrEmpty = (value:string):boolean => {
    if(IsNull(value))
        return true;
    if(IsEmpty(value))
        return true;

    return false;
}